export class UserDetails{
    email: string;
    ds_Logo: string;
    is_Pln: number;
    is_Ressarcimento: number;
    is_Rpl: number;
    is_Rus: number;
    mensagemRetorno: string;
    modulos: Array<number>;
    nm_Nome: string;
    nm_Senha: string;
    nm_Senha_Salt: string;
    statusRetorno: number;
    tp_Nivel_Master: boolean;
    exibe_Medicamento: boolean;
    utiliza_Cadastro_Dinamico: boolean;
    param_is_pln: number;
}
